import Logo from "../assets/logo1.svg";
import { useEffect } from "react";
import video from "../assets/06.mov";
import { Link } from "react-router-dom";



export default function MedicalRecord() {
  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });

    document.title = "Prontuário com inteligência Artificial - Sonafe 2025";
  }, []);


  return (
    <main className="flex-1 h-auto min-h-screen flex flex-col items-center justify-between bg-white w-full">
      <div className="w-full max-w-[720px] flex flex-col items-center px-4 pt-6">
        <header className="w-full flex items-center justify-center mb-8">
          <Link
            to="/"
            className="w-full flex items-center justify-center cursor-pointer"
          >
            <img
              src={Logo}
              alt="ScalLogo"
              className="w-32 sm:w-40 md:w-48 lg:w-56 h-auto object-contain"
            />
          </Link>
        </header>
        <section className="w-full py-8 px-6 sm:px-8 rounded-2xl flex flex-col gap-4  items-center text-center ">
          <iframe
            width="315"
            height="560"
            src="https://youtube.com/embed/l_DPKvG_OdY?si=KXth2KK4jnBqEQFX"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            className="w-full max-w-lg rounded-lg"
          ></iframe>

          <button
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send/?phone=5511918564424&text=Quero+ver+como+funciona+o+prontu%C3%A1rio+com+voz+por+IA.&type=phone_number&app_absent=0"
              )
            }
            className="w-full py-6 bg-[#FB842E] rounded-md text-white font-bold mt-8  transition-colors duration-1000"
          >
            Quero usar esse recurso
          </button>
        </section>
      </div>

      <footer className="w-full flex justify-center ">
        <div className="w-full max-w-[720px] h-40 flex items-center justify-center bg-[#F5F5F5]">
          <img
            src={Logo}
            alt="ScalLogo"
            className="w-24 sm:w-32 h-auto object-contain"
          />
        </div>
      </footer>
    </main>
  );
}
